import Layout from '@/layout';
export default [
  {
    path: '/creation',
    name: 'Creation',
    component: Layout,
    redirect: '/creation/afflatus',
    meta: {
      title: '创作灵感',
      icon: 'icon-creation',
    },
    children: [
      {
        path: 'afflatus',
        name: 'creative-afflatus',
        component: () => import('@/views/creation/afflatus.vue'),
        meta: {
          title: '创作洞察',
        },
      },
      {
        path: 'collgeg',
        name: 'College',
        // component: () => import('@/views/creation/college.vue'),
        meta: {
          title: '开发者学院',
        },
        hidden: true,
      },
    ],
  },
];
